import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { MatButton } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { UsernameIconComponent } from "../../shared/ui/username-icon/username-icon.component";
import { UserInfos } from "../../shared/ui/username-icon/user-infos.type";
import { HeaderMenuEntry } from "../header.type";
import { RouterLink } from "@angular/router";

@Component({
    selector: "header-menu",
    templateUrl: "./header-menu.component.html",
    styleUrls: ["./header-menu.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatMenuModule,
        MatButton,
        UsernameIconComponent,
        RouterLink
    ]
})
export class HeaderMenuComponent{

    @Input() menuName: string
    @Input() menuIcon: string
    @Input() menuTitle: string
    @Input() userInfos: UserInfos
    @Input() menuItems: HeaderMenuEntry[]

    constructor() { }
}


